export const heroTrainingBusinessText = {
  en: {
    title: ["Business Coaching"],
    subtitle: "",
  },
  vi: {
    title: ["Coaching Doanh nghiệp"],
    subtitle: " ",
  },
};

export const quoteTrainingBusinessText = {
  en: {
    title: "Develop Leaders. Empower Teams. Drive Profit.",
    desc: "Unlock your business’s full potential with our tailored training and coaching programs. We help business owners and teams develop strong leadership, improve team performance, and increase profitability.",
    cta: "Join the Program",
  },
  vi: {
    title: "Phát triển Lãnh đạo. Nâng tầm Đội ngũ. Tăng trưởng Doanh thu.",
    desc: "Khai phá toàn bộ tiềm năng doanh nghiệp với các chương trình đào tạo và coaching được thiết kế riêng. Chúng tôi giúp chủ doanh nghiệp và đội ngũ xây dựng năng lực lãnh đạo, nâng cao hiệu suất làm việc và gia tăng lợi nhuận.",
    cta: "Tham gia chương trình",
  },
};

export const trainingListBusinessData = {
  en: [
    {
      id: 1,
      icon: "GraduationCap",
      title: "About the Program",
      description:
        "Great businesses are built by skilled leaders and high-performing teams. Our Training & Coaching for Business programs help business owners, managers, and employees develop the right skills, adopt effective strategies, and achieve measurable results.",
      list: [],
    },
    {
      id: 2,
      icon: "Users",
      title: "What You Gain:",
      description: "",
      list: [
        "Leadership & Management Excellence: Equip leaders to inspire, guide, and grow their teams.",
        "Operational Efficiency: Learn proven techniques to streamline workflows and boost productivity.",
        "Profit-Driven Strategies: Apply actionable insights to improve performance and increase ROI.",
        "Customized Coaching: Tailored sessions for your business challenges and goals.",
        "Team Motivation & Engagement: Build a culture of accountability, collaboration, and innovation.",
        "Sustainable Growth: Empower your business with long-term strategies that deliver real impact.",
      ],
    },
    {
      id: 3,
      icon: "Brain",
      title: "How It Works",
      description: "",
      list: [
        "Whether you want to upskill your leaders, optimize your operations, or build a high-performing team, our coaching programs provide the tools and support you need to achieve your business goals.",
        "Transform Your Business Today – Train, Coach, and Grow with Confidence.",
      ],
    },
  ],

  vi: [
    {
      id: 1,
      icon: "GraduationCap",
      title: "Giới Thiệu Chương Trình",
      description:
        "Doanh nghiệp thành công được xây dựng bởi những nhà lãnh đạo giỏi và đội ngũ hiệu suất cao. Chương trình Đào tạo & Coaching cho Doanh nghiệp giúp chủ doanh nghiệp, quản lý và nhân viên phát triển kỹ năng phù hợp, áp dụng chiến lược hiệu quả và đạt được kết quả rõ ràng.",
      list: [],
    },
    {
      id: 2,
      icon: "Users",
      title: "Bạn sẽ đạt được:",
      description: "",
      list: [
        "Nâng cao năng lực lãnh đạo & quản lý: Giúp lãnh đạo truyền cảm hứng, dẫn dắt và phát triển đội ngũ.",
        "Tối ưu vận hành: Áp dụng các phương pháp hiệu quả để cải thiện quy trình và tăng năng suất.",
        "Chiến lược tăng trưởng lợi nhuận: Ứng dụng giải pháp thực tế để nâng cao hiệu quả kinh doanh và ROI.",
        "Coaching theo nhu cầu: Nội dung được thiết kế phù hợp với mục tiêu và thách thức của doanh nghiệp.",
        "Tăng động lực & gắn kết đội ngũ: Xây dựng văn hoá trách nhiệm, hợp tác và đổi mới.",
        "Phát triển bền vững: Trang bị chiến lược dài hạn giúp doanh nghiệp tăng trưởng ổn định.",
      ],
    },
    {
      id: 3,
      icon: "Brain",
      title: "Cách Chúng Tôi Đồng Hành",
      description: "",
      list: [
        "Dù bạn muốn nâng cao năng lực lãnh đạo, tối ưu vận hành hay xây dựng đội ngũ hiệu suất cao, chương trình coaching cung cấp công cụ và sự hỗ trợ cần thiết để đạt mục tiêu kinh doanh.",
        "Chuyển hoá doanh nghiệp ngay hôm nay – Đào tạo, Coaching và Tăng trưởng bền vững.",
      ],
    },
  ],
};

export const trainingBusinessCTA = {
  en: {
    text: "Invest in People, Transform Your Business, and Maximize Profit Today.",
    button1: "Contact Us Now →",
    button2: "",
  },
  vi: {
    text: "Đầu tư vào con người, chuyển hóa doanh nghiệp và tối đa hóa lợi nhuận ngay hôm nay.",
    button1: "Liên hệ ngay →",
    button2: "",
  },
};
